import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IBrandigApiProps } from '@boxx/dynamic-branding';

export interface ILoginRepository {
  login(
    form: ILoginForm | ISocialLoginForm
  ): Observable<IHttpBasicResponse<ILoginDataResponse>>;
  socialLogin(
    form: ISocialLoginForm
  ): Observable<IHttpBasicResponse<ISocialLoginDataResponse>>;
  saveFCMToken(
    deviceId: string,
    deviceToken: string
  ): Observable<IHttpBasicResponse<any>>;
  logSessionStart(
    payload: ILogSessionPayload
  ): Observable<IHttpBasicResponse<any>>;
  sendPasswordRecoveryEmail(
    email: string
  ): Observable<JsonApiResponse<{ action: string }>>;
  getThemeData(brand: string): Observable<JsonApiResponse<IBrandigApiProps>>;

  deleteAccount(): Observable<JsonApiResponse<any>>;
  sendRecoveryCode(
    email: string
  ): Observable<IHttpBasicResponse<any>>;
  sendDeleteCode(
    email: string
  ): Observable<IHttpBasicResponse<any>>;
  deleteUser(
    code: string
  ): Observable<IHttpBasicResponse<any>>;
  validateResetCode(
    data: any
  ): Observable<IHttpBasicResponse<any>>;
  resetPassword(
    data: any
  ): Observable<IHttpBasicResponse<any>>;
}

export const LOGIN_REPOSITORY = new InjectionToken<ILoginRepository>(
  'loginRepository'
);

export interface ILoginForm {
  user: string;
  password: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  device_id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  device_model: string;
}

export interface ILoginDataResponse {
  token: string;
  brand?: any;
}

export interface ISocialLoginForm {
  email: string;
  uid: string;
  type: 'facebook' | 'google' | 'unknown';
}

export interface ISocialLoginDataResponse {
  token: string;
}

export interface ISaveTokenDataResponse {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  user_id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  device_id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  fcm_registration_id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  created_at: string;
}

export interface ILogSessionPayload {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  action_type: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  action_description?: string;
}
